export default __webpack_public_path__ + "static/media/payment3.a41511f5.webp";